import { render, staticRenderFns } from "./BotaoAssinarDocumentoEmLote.vue?vue&type=template&id=cf920ed2&scoped=true"
import script from "./BotaoAssinarDocumentoEmLote.vue?vue&type=script&lang=js"
export * from "./BotaoAssinarDocumentoEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf920ed2",
  null
  
)

export default component.exports